
//UI related items

let layout_type = {
    page : "page",
    tab_area : "tab-area"
};

let events = {
    click : "click",
    change : "change"
};

let pages = {

    common : {
        html : {
            btn_next : "next-button",
            btn_previous : "previous-button",
            text_header : "header-text",
        },
        image : {
            nsre_logo_path : "Media/nsre-logo.png"
        }
    },
    landing: {
        layout : layout_type.page,
        path: "./views/myga/landing.html",
        html : {
            btn_start_now : "button-start"
        }
    },
    login: {
        layout : layout_type.page,
        path: "./views/myga/login.html",
        html : {
            btn_login : "login"
        }
    },
    dashboard: {
        layout : layout_type.page,
        path: "./views/myga/dashboard.html",
        html : {
            btn_apply : "apply_button",
            text_rates : "text-rates",
            text_alternatives : "text-alternatives",
            text_shopping_cart : "text-shopping-cart",
            text_holdings : "text-holdings",
            text_rate_6yr : "text-rate-6yr",
            text_rate_4yr : "text-rate-4yr",
            okta_container : "okta-container"

        }
    },
    process_overview: {
        layout : layout_type.page,
        path: "./views/myga/process-overview.html",
        html : {
            text_handy_title: 'text-handy-title',
            text_item_title : "text-item-title",
            text_item_id : "text-item-id",
            text_item_ssn : "text-item-ssn",
            text_item_birthdays : "text-item-birthdays",
            text_item_bank_info : "text-item-bank-info",
            text_game_plan : "text-game-plan",
            text_plan_1_desc : "text-plan-1-desc",
            text_plan_1_est : "text-plan-1-est",
            text_plan_2_desc : "text-plan-2-desc",
            text_plan_2_est : "text-plan-2-est",
            text_plan_3_desc : "text-plan-3-desc",
            text_plan_3_est : "text-plan-3-est",
            text_plan_4_desc : "text-plan-4-desc",
            text_plan_4_est : "text-plan-4-est",
            text_plan_5_desc : "text-plan-5-desc",
            text_plan_5_est : "text-plan-5-est",
            text_plan_6_desc : "text-plan-6-desc",
            text_plan_6_est : "text-plan-6-est"
        }
    },
    deposit: {
        layout : layout_type.tab_area,
        path: "./views/myga/deposit.html",
        form_id : "deposit",
        html : {
            text_rate_4yr : "text-rate-4yr",
            text_rate_6yr : "text-rate-6yr",
            text_product_4yr : "text-product-4yr",
            text_product_6yr : "text-product-6yr",
            text_term_4yr : "text-term-4yr",
            text_term_6yr : "text-term-6yr",
            info_term_4yr : "info-term-4yr",
            info_term_6yr : "info-term-6yr",
            input_deposit_6yr : "year6Deposit",
            input_deposit_4yr : "year4Deposit",
            text_fwd_4yr : "text-fwd-4yr",
            text_fwd_6yr : "text-fwd-6yr",
            slider_deposit_6yr : "year6DepositSlider",
            slider_deposit_4yr : "year4DepositSlider",
            text_total_interest_4yr : "text-total-interest-4yr",
            text_first_interest_4yr : "text-first-interest-4yr",
            info_first_interest_4yr : "info-first-interest-4yr",
            text_total_interest_6yr : "text-total-interest-6yr",
            info_first_interest_6yr : "info-first-interest-6yr",
            text_first_interest_6yr : "text-first-interest-6yr"


        }
    },
    finances: {
        layout : layout_type.tab_area,
        path: "./views/myga/finances.html",
        form_id : "finances",
        html : {
            select_income : "select-income",
            info_income : "info-income",
            info_replacement : "info-replacement"
        }
    },
    goals: {
        layout : layout_type.tab_area,
        path: "./views/myga/goals.html",
        form_id : "goals",
        html : {
            text_qualified_funds : "question-qualified-funds-label",
            text_early_access : "question-early-access-label",
            text_adequate_savings : "question-adequate-savings-label",
            text_question_replacement : "question-replacement-label",
            text_stop_payments : "question-stop-payments-label",
            info_qualified_funds : "info-qualified-funds",
            info_early_access : "info-early-access",
            info_adequate_savings : "info-adequate-savings",
            info_question_replacement : "info-replacement",
            info_stop_payments : "info-stop-payments"

        }
    },
    id_verify: {
        layout : layout_type.tab_area,
        path: "./views/myga/id-verify.html",
        form_id : "id-verify",
        html : {
            btn_take_picture : "takePicture",
            btn_enter_info : "enterId"
        }
    },
    id_data_entry: {
        layout : layout_type.tab_area,
        path: "./views/myga/id-data-entry.html",
        form_id : "id-data-entry",
        html : {
            btn_update : "updateId",
            input_first_name : "firstName",
            input_last_name : "lastName",
            input_dob : "dob",
            input_street_address : "street_address",
            input_state : "state",
            input_city : "city",
            input_zip : "zip",
            select_id_type : "idType",
            input_id_number : "idNumber",
            input_id_expiration : "expDate"
        }
    },
    id_finish: {
        layout : layout_type.tab_area,
        path: "./views/myga/id-finish.html",
        form_id : "id-finish"
    },
    bene: {
        layout : layout_type.tab_area,
        path: "./views/myga/beneficiary.html",
        form_id : "bene",
        html : {
            btn_update : "updateBene",
            btn_cancel : "cancelBene",
            btn_remove : "removeBene",
            btn_confirm_removal : "confirmRemoval"

        }
    },
    benes: {
        layout : layout_type.tab_area,
        path: "./views/myga/beneficiaries.html",
        html : {
            btn_add : "addBene",
            btn_finish : "finishBenes",
            info_benes_primary : "info-benes-primary",
            info_benes_contingent : "info-benes-contingent"
        }
    },
    payment: {
        layout : layout_type.tab_area,
        path: "./views/myga/payment.html",
        form_id : "payment",
        html : {
            btn_return : "return"
        }
    },
    payments: {
        layout : layout_type.tab_area,
        path: "./views/myga/payments.html"
    },
    finalize: {
        layout : layout_type.tab_area,
        path: "./views/myga/finalize.html"
    },
    eft_info: {
        layout : layout_type.tab_area,
        path: "./views/myga/eft-info.html"
    },
    mail_check_info: {
        layout : layout_type.tab_area,
        path: "./views/myga/mail-check-info.html"
    },
    submit_app: {
        layout : layout_type.tab_area,
        path: "./views/myga/submit-app.html",
        html : {
            text_please_review: "text-please-review",
            text_fine_print: "text-fine-print",
            input_consent_disclosure: "input-consent-disclosure",
            text_consent_disclosure: "text-consent-disclosure",
            input_consent_signature: "input-consent-signature",
            text_consent_signature: "text-consent-signature"

        }
    },
    app_completed: {
        layout : layout_type.tab_area,
        path: "./views/myga/app-completed.html",
        html : {
            text_completed_message : "text-completed-message",
            text_receive_email_label : "text-receive-email-label",
            text_receive_email_message : "text-receive-email-message",
            text_review_application_label : "text-review-application-label",
            text_review_application_message : "text-review-application-message",
            text_making_payment_label : "text-making-payment-label",
            text_making_payment_message : "text-making-payment-message",
            text_have_contract_label : "text-have-contract-label",
            text_have_contract_message : "text-have-contract-message",
            text_fine_print : "text-fine-print"

        }
    }

};

export default pages;


